import { REWARD_FAQ } from './faq';
import { REWARD_LICENSE } from './license';
import { REWARD_OVERVIEW } from './overview';
import { REWARD_SUPPORT } from './support';
import { REWARD_TERMS } from './terms';

export const VIEW_REWARD = { REWARD_FAQ, REWARD_LICENSE, REWARD_OVERVIEW, REWARD_SUPPORT, REWARD_TERMS };
